module.exports = __webpack_public_path__ + "img/pc@2x.5681081.png";